<template lang="pug">
div
  //- 用户协议
  .dyt-protocol
    .iframe-wrap
      iframe(:src="src")
    .dyt-btn-group
      .btn.commit(@click='goBack') 关闭
</template>

<script>
export default {
  props: ['src'],
  methods: {
    goBack() {
      this.$router.back()
    }
  }
}
</script>

<style lang="less" scoped>
@import '../styles/base';
@import '../styles/dyt-ui.less';
</style>
